// extracted by mini-css-extract-plugin
module.exports = {"Onboarding":"Onboarding_Onboarding__0HpiI","spinner":"Onboarding_spinner__D3l2Z"};